//collections/recipes.tsx
import { buildCollection, buildProperty,  buildEntityCallbacks,EntityOnPreSaveProps,EntityOnDeleteProps,} from "@firecms/core";
import { recipeCallbacks } from "../callbacks/recipeCallbacks";
import { Recipe } from "../types/recipeTypes";


export const recipesCollection = buildCollection<Recipe>({
  name: "Recipes",
  singularName: "Recipe",
  id: "recipes",
  path: "recipes",
  icon: "RestaurantMenu",
  group: "Content",
  callbacks: recipeCallbacks,
  permissions: ({ authController, user }) => ({
    read: true,
    edit: true,
    create: true,
    delete: true
  }),
  properties: {
    enabled: buildProperty({
     name: "Status",
      dataType: "boolean",
      description: "Toggle to show or hide this recipe in the app",
      defaultValue: true // Recipes will be active by default when created
      
    }),
    order: buildProperty({
      name: "Order",
      dataType: "number",
      description: "Lower numbers appear first",
      validation: {
        required: true,
        min: 0
      },
      defaultValue: 0
    }),

    name: buildProperty({
      name: "Name",
      dataType: "string",
      validation: {
        required: true,
        minLength: 3,
      }
    }),

    color: buildProperty({
      name: "Colour",
      dataType: "string",
      description: "Enter a valid hex color (e.g., #ff5733)",
      validation: {
        required: true,
        custom: (value:string) => {
          const hexRegex = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i;
          if (!value || !hexRegex.test(value)) {
            console.log(`Validation failed for color: ${value}`); // Debug log
            return "Invalid hex color. Use format #RRGGBB or #RGB.";
          }
          return true;
        }
      }
    }),

    hero_image: buildProperty({
      name: "Hero Image",
      dataType: "string",
      storage: {
        storagePath: "images/hero",
        acceptedFiles: ["image/*"]
      }
    }),

    product_image: buildProperty({
      name: "Product Image",
      dataType: "string",
      storage: {
        storagePath: "images/products",
        acceptedFiles: ["image/*"]
      }
    }),
    product_height: buildProperty({
      name: "Product Height",
      dataType: "number",
      description: "Defines the height of the product image in pixels",
      validation: { required: false, min: 50, max: 500 },
      defaultValue: 150, // Default height if not set
    }),

    thumbnail_image: buildProperty({
      name: "Thumbnail Image",
      dataType: "string",
      storage: {
        storagePath: "images/thumbnails",
        acceptedFiles: ["image/*"]
      }
    }),

    description: buildProperty({
      name: "Description",
      description: "Short description of the recipe",
      validation: { required: true },
      dataType: "string",
      multiline: true
    }),

    ingredients: buildProperty({
      name: "Ingredients",
      description: "List of ingredients",
      markdown: true,
      validation: { required: true },
      dataType: "string"
    }),

    preparation_steps: buildProperty({
      name: "Preparation Steps",
      description: "Step-by-step preparation instructions",
      markdown: true,
      validation: { required: true },
      dataType: "string"
    })
  }
});

